import LazyImage from '../LazyImage';
import { stockIntro } from '../../list/stockIntro';

export function PartsTypeIntro() {
    return(
        <div className="intro_spare_parts">
            {stockIntro.map ((item,index) =>{
                return(
                    <div className="key_intro_spare_parts" key={index}>
                        <LazyImage className="parts_intro_img" src={item.image} alt="tractor"/>
                        <div className="parts_intro_title">{item.title}</div>
                        <div className="parts_button_container">
                            <button className="button" style={{height: "40%"}}>Check the stock</button>
                        </div>
                    </div>
                );
            })}
        </div>
    );
    
}